
import ProductResourceView from '@/mixins/ProductResourceView';

export default {
  name: 'AppNoProduct',
  mixins: [ProductResourceView],
  computed: {
    anySelectedFilters() {
      const { category_id, price_range, query } = this.resourceParams;
      return !!category_id || !!price_range || !!query;
    },
    noItemMessage() {
      const type = this.anySelectedFilters ? 'filtered' : 'none';
      return this.$t(`no_item_message.${type}`);
    }
  }
};
